import React , { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Signup from './pages/Signup';
import Login from './pages/Login';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Common/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Footer from './components/Common/Footer';
import Newsletter from './components/Newsletter';
import Submit from './pages/Submit';
import AgencyArchive from './pages/AgencyArchive';
import ArticleArchive from './pages/ArticleArchive';
import SingleAgencyPage from './pages/SingleAgencyPage';
import ArticlePage from './pages/ArticlePage';
import Payments from './pages/Payments';
import UserDashboard from './pages/UserDashboard';
import EditAgency from './pages/EditAgency';
import SearchResults from './pages/SearchResults';
import Fail from './components/Stripe/Fail';
import Success from './components/Stripe/Success';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfServices from './pages/TermsOfServices';
import Cookies from './pages/Cookies';
import ContactUs from './pages/Contact';
import { HelmetProvider } from 'react-helmet-async';
import AutomationLanding from './pages/AutomationLanding';
import ConsultationSignUp from './pages/ConsultationSignUp';
import CalendlyFloatingButton from './components/CalendlyFloatingButton';
import JobAutomationReport from './pages/JobAutomationReport';

function App() {

  return (
    <HelmetProvider>
    <AuthProvider>
      <Router>
        <Navbar />
        <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/newsletter" element={<Newsletter />} />
          <Route path="/submit-agency" element={<PrivateRoute><Submit /></PrivateRoute>} />
          <Route path="/agencies" element={<AgencyArchive />} />
          <Route path="/consultation" element={<ConsultationSignUp />} />
          <Route path="/agency/:agencyId" element={<SingleAgencyPage />} />
          <Route path="/blogs" element={<ArticleArchive />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/edit-agency/:agencyId" element={<EditAgency />} />
          <Route path="/search-results" element={<SearchResults />} />
          <Route path="/automation" element={<AutomationLanding />} />
          <Route path='/fail' element={<Fail />} />
          <Route path='/success' element={<Success />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/terms-of-service' element={<TermsOfServices />} />
          <Route path='/cookie-policy' element={<Cookies />} />
          <Route path='/contact' element={<ContactUs />} />
          <Route path="/automation-report" element={<JobAutomationReport />} />
        </Routes>
        </Suspense>
        <CalendlyFloatingButton />
        <Footer />
      </Router>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
